// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/mall_manage/ssss.css
// module id = 2620
// module chunks = 2